import React, { useEffect, useState } from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import URL from "../../constant/URL";
import Button from "../common/Button";
import SelectBox from "../common/SelectBox";
import AnsweringQuestions from "./answering/AnsweringQuestions";
import NewAnsweringQuestions from "./newAnswering/NewAnsweringQuestions";
import MathpixNotesTest from "./mathpix/MathpixNotesTest";

const ANSWERING_QUESTIONS = `${ URL.SAMPLE }/answering`;
const NEW_ANSWERING_QUESTIONS = `${ URL.SAMPLE }/newAnswering`;
const MATHPIX_NOTES_TEST = `${ URL.SAMPLE }/mathpix`;
const ANSWERING_QUESTIONS_FOR_PLAIN_JS = `${ process.env.PUBLIC_URL }/static/sample/AnsweringQuestions.html`;

const selectBoxData = [
  { label : 'Answering Questions', data : ANSWERING_QUESTIONS },
  { label : 'New Answering Questions', data : NEW_ANSWERING_QUESTIONS },
  { label : 'Mathpix Notes Test', data : MATHPIX_NOTES_TEST },
  { label : 'Answering Questions For Plain JS', data : ANSWERING_QUESTIONS_FOR_PLAIN_JS }
];

const question = '~~~~~~~~~~~~~~~~~~~~~~~~~~~(3|2는~32분)\\\\\r\n~~~~~~~\\begin{array} {|r|r|} \\hline 줄기 & 잎~~~~~~~~~~~ \\\\ \r\n\\hline 3~~~ & ~2~~~4~~~8~~~~~~~~~~~~ \\\\ \r\n4~~~ & 2~~~2~~~3~~~6~~~7~~ \\\\ \r\n5~~~ & 1~~~5~~~9~~~9~~~~~~~ \\\\\r\n6~~~ & 0~~~5~~~~~~~~~~~~~~~~~ \\\\ \\hline \\end{array} \\\\ \r\n1.~줄기는~3,~\\boxed{\\cssId{inputArea0}{4}},~\\boxed{\\cssId{inputArea1}{5}},~\\boxed{\\cssId{inputArea2}{6}}이다. \\\\\r\n2.~줄기가~3인~잎은~2,~\\boxed{\\cssId{inputArea3}{4}},~\\boxed{\\cssId{inputArea4}{8}}이다. \\\\\r\n3.~잎이~가장~많은~줄기는~\\boxed{\\cssId{inputArea5}{4}}이다. \\\\\r\n4.~잎이~가장~적은~줄기는~\\boxed{\\cssId{inputArea6}{6}}이다.';

const Sample = () => {

  const [ selectBoxValue, setSelectBoxValue ] = useState( selectBoxData[ 0 ] );

  const history = useHistory();
  const routeMatch = useRouteMatch();

  useEffect( () => {
    switch ( selectBoxValue.data ) {
      case ANSWERING_QUESTIONS_FOR_PLAIN_JS :
        window.location.href = selectBoxValue.data;
        break;
      default :
        history.push( selectBoxValue.data );
    }
  }, [ selectBoxValue ] );

  const goBack = () => {
    if ( window.aicalculator ) {
      window.aicalculator.killApp();
    } else {
      history.goBack();
    }
  };

  return (
    <div>
      <div style={ { padding : 20, display : 'inline-flex', width : '100%' } }>
        <Button className="ss-complex-item btn btn-blue h48" style={ { width : 70 } } onClick={ goBack }>Back</Button>
        <SelectBox className="ss-complex-item new-select" style={ { width : 380 } } data={ selectBoxData } value={ selectBoxValue } onChange={ setSelectBoxValue } />
      </div>
      <br />
      <Route path={ `${ routeMatch.url }/:depth3` }><Children /></Route>
    </div>
  );

};

const Children = () => {

  return (
    <Switch>
      <Route path={ ANSWERING_QUESTIONS }><AnsweringQuestions>{ question }</AnsweringQuestions></Route>
      <Route path={ NEW_ANSWERING_QUESTIONS }><NewAnsweringQuestions>{ question }</NewAnsweringQuestions></Route>
      <Route path={ MATHPIX_NOTES_TEST }><MathpixNotesTest /></Route>
    </Switch>
  );

};

export default Sample;
